module.exports = __webpack_public_path__ + "static/media/37.b6cc7d03.JPG";